import * as actionsConfig from '../actions/configAction';
import HttpService from './HttpService';
import { getUrlPlantApi, translate, showMessageToastCustom, getApiKeyLogistics, parseParams } from '../utils/util';
import { startLoading, endLoading } from '../actions/loadingAction';
import * as plantAction from '../actions/plantAction';
import { ENUMS } from '../utils/constants';

const httpService = new HttpService(getUrlPlantApi(window), getApiKeyLogistics(window));

export default class PlantService {
    static searchSheds(vision, callback) {
        return (dispatch) => {
            const company = vision.split('-')[0];
            if (navigator.onLine) {
                const url = 'api/area/areasWithFilter';
                var filter = {
                    plantId: company,
                    areaTypes: ['SHED', 'YARD']
                };

                httpService.instance.get(url, {
                    params: filter,
                    paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    },
                    timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout')

                }).then((response) => {
                    dispatch(actionsConfig.updateSheds([]));
                    if (response?.data?.data) {

                        let areas = [];
                        response.data.data.filter((i) => i.modalityArea && i.modalityArea.length > 0).map((i) => {
                            return i.modalityArea.map((m) => areas = [...areas, {
                                areaId: m.areaId,
                                modality: m.modality === ENUMS.eModality.Load.value ? 'LOAD' : (m.modality === ENUMS.eModality.Unload.value ? 'UNLOAD' : ''),
                                modalityId: m.modality,
                                code: i.code,
                                text: i.description,
                                id: m.codAux,
                                automaticPrint: i.automaticPrint,
                                enableFifoControl: i.enableFifoControl,
                                latitude: i.latitude,
                                longitude: i.longitude,
                                units: i.units,
                                dataStatus: 'R',
                                companyId: company,
                                vision
                            }]);
                        });
                        dispatch(actionsConfig.updateSheds(areas));
                        if (callback) {
                            callback();
                        }
                    }
                });
            }
        };
    }

    static searchDocks(shedId, callback) {
        if (shedId !== '' && shedId !== undefined && shedId !== null) {
            if (navigator.onLine) {
                const url = '/graphql';
                const payload = {
                    query: `
                        query {
                            docks(shedId: ${shedId}){
                                id: dockId                                
                                code                                
                                text: description                                
                            }
                        }`
                };
                return (dispatch) => {
                    httpService.instance.post(url, payload).then((response) => {
                        dispatch(actionsConfig.updateDocks(response.data.data.docks));
                        if (callback) {
                            callback();
                        }
                    });
                };
            }
            if (callback) {
                callback();
            }
        } else {
            return (dispatch) => {
                dispatch(actionsConfig.updateDocks([]));
                if (callback) {
                    callback();
                }
            };
        }
    }

    static clearSheds() {
        return (dispatch) => {
            dispatch(actionsConfig.resetSheds());
        };
    }

    static clearDocks() {
        return (dispatch) => {
            dispatch(actionsConfig.resetDocks());
        };
    }

    static live(callback) {
        const url = 'api/Live';
        return () => {
            if (navigator.onLine) {
                httpService.instance.get(url).then((response) => {
                    callback(response);
                }).catch((error) => {
                    callback(error);
                })
            }
        };
    }

    static getPlants(vision, filter, pagination) {
        pagination.PageSize = 40;
        Object.assign(filter, pagination);
        const url = 'api/plant';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(plantAction.setPlants(response.data.data));
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static AddPlant = (plant, callback) => {
        const url = 'api/plant';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, plant, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 201) {
                        if (callback) {
                            callback(response.data);
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), response?.data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static PutPlant = (plant, callback) => {
        const url = 'api/plant';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, plant, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(response.data);
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), response?.data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static DeletePlant = (plantId, callback) => {
        const url = 'api/plant';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.delete(`${url}/${plantId}`, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 204) {
                        if (callback) {
                            callback({ message: "Item excluido com sucesso" });
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), response?.data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static DeleteSelectedPlants(ids, callback) {
        if (navigator.onLine) {
            const url = `/api/plant/selected`;
            return (dispatch) => {
                if (navigator.onLine) {
                    dispatch(startLoading());
                    httpService.instance.put(url, ids, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                        if (response.status === 200) {
                            if (callback) {
                                callback({ message: "Itens excluidos com sucesso" });
                            }
                        } else {
                            showMessageToastCustom(translate('warning', 'general'), response?.data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                        }
                    }).catch((error) => {
                        dispatch(endLoading());
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
                }
            };
        }
    }
}
